import { createFileRoute } from "@tanstack/react-router";

import { Cost } from "~/components/feature/results/components";

export const Route = createFileRoute("/_app/dashboard/results/cost/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Cost />;
}
